import React from "react"
import { Box, Flex, Link } from "rebass"

const Links = ({ links }) => (
  <Box sx={{ borderColor: "text" }} css={{ borderBottom: "2px solid" }}>
    <Flex alignContent="space-between" flexWrap="wrap">
      {links.map((link, index) => (
        <Link
          key={link.retailer}
          flex="auto"
          sx={{
            textAlign: "center",
            borderTop: "2px solid",
            "&:last-of-type": {
              borderRight: [0, "2px solid"],
            },
            borderRight: "2px solid",
          }}
          p={3}
          variant="hyperlink"
          target="_blank"
          href={link.url}
        >
          <span>{link.retailer}</span>
        </Link>
      ))}
    </Flex>
  </Box>
)

export default Links
